<div *ngIf="commonService.supplierRole"
  class="noaccess">
  {{commonService.Notautorized}}
</div>
<div *ngIf="!commonService.supplierRole">
<div class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
  <section id="Noprop" class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 m-0">
    <div class="d-flex align-items-center m-0 pb-1">
      <div class="col-4 pl-0">
        <button type="button" class="btn btn-green btn-custom btn-blue mr-2 btn-ht" [routerLink]="['/bvd']"
          *ngIf="showForConsult">
          <mat-icon svgIcon="add-2" class="img-btn img-btn-md"></mat-icon><span class="float-right">Import a
            Supplier</span>
        </button>
        <button *ngIf="superUserShow" class="btn btn-custom btn-custom-md btn-darkred mr-2 btn-ht"
          data-target="#payingDataModal" data-toggle="modal" (click)="loadPayingDatabase()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (loadPayingDatabase())">
          Paying Company Database
        </button>
      </div>
      <div class="center col-4 text-center"> <img src="assets/images/RG_RENAULT_GROUP_LOGOTYPE_BLACK_RGB_v21_1.png"
          class="renault-logo" alt="edit"></div>
      <div class="col-4 text-right">
        <div> <app-helpsection></app-helpsection></div>

      </div>
    </div>

  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0 search-panel">
    <app-suppliertab></app-suppliertab>
    <div class="row m-0 align-center">
      <div class="col col-12 col-sm-6 col-md-8 col-lg-8 col-xl-6">
        <h4 class="title">SEARCH</h4>
      </div>
      <div class="col col-12 col-sm-6 col-md-4 col-lg-4 col-xl-6" *ngIf="roleVariableHide">
        <button type="button" class="btn btn-custom btn-darkred float-right btn-custom-padding" data-toggle="modal"
          data-target="#createCompanyModalPopup" id="testing"
          (click)="updateCreateCompanyExistsName()" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (updateCreateCompanyExistsName())">
          <mat-icon class="icon-padding-top" svgIcon="add-2"></mat-icon> <span class="float-right span-padding-top"> Create Company </span>
        </button>
      </div>
    </div>

    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
        <mat-label class="label-control">Company name
        </mat-label>
        <p class="pr-4 m-0">
        <div class="form-control form-control-sm matformheight">
          <form class="form-width-325">
            <mat-form-field class="form-width-325">
              <input class="form-width-325" matInput aria-label="State" [matAutocomplete]="auto"
                (keydown)="resetOtherFields('IdentifierValueModel',$event)" (keyup)="onItemKey($event)"
                [formControl]="userQuestionUpdate2">
              <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete autocomplete-display-block">
                <ng-container *ngIf="CmpNameValue.length > 0 && enterKey; else noResults">
                  <mat-option class="form-width-325" *ngFor="let value of CmpNameValue" (click)="onCompNameSelect(value)"
                    [value]="value" (keydown)="onCompNameSelect(value)">
                    <span>{{ value }}</span>
                  </mat-option>
                </ng-container>
                <ng-template #noResults>
                  <mat-option class="noResults" disabled *ngIf="CmpNameeModel.length >= 5 && !autoload && enterKey">
                    <span>No results</span>
                  </mat-option>
                </ng-template>
              </mat-autocomplete>
            </mat-form-field>
            <small class="float-right search-close-btn" title="Clear"><button
              type="button"
              class="cancel closeBtn"
              (click)="clearFields('companyNameFLag')"
              (keydown.enter)="clearFields('companyNameFLag')"
              (keydown.space)="clearFields('companyNameFLag')"
              tabindex="0">X</button></small>
            <small class="float-right search-close-btn" *ngIf="autoload"><img src="assets/images/loading.gif"
                class="loadingheight" alt="Updating..."></small>
          </form>
        </div>
      </div>
    </div>

    <div class="row m-0 ml-3 align-center">
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
      <span class="px-2 font-weight-bold">OR</span>
      <div class="border-bottom-custom col col-5 col-sm-5 col-md-5 col-lg-3 col-xl-3"></div>
    </div>

    <div class="row m-0 align-center">
      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 pb-0 mb-0">
        <mat-label class="label-control">Identifier Type</mat-label>
        <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="CIdentifierTypeModel"
          (selectionChange)="restAlldatas($event)" panelClass="dropdown-panel" [disableOptionCentering]="true">
          <mat-option *ngFor="let CIdentifierType of CIdentifierTypes"
            value="{{CIdentifierType}}">{{CIdentifierType}}</mat-option>
        </mat-select>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 mt-3">
        <mat-label class="label-control">Identifier Value
        </mat-label>
        <div class="pr-4 m-0" *ngIf="activityDropdown">
          <mat-select class="form-control form-control-sm dropdown-select" [formControl]="activityTypeCtrl"
            panelClass="activity-dropdown-panel" (selectionChange)="onActivityTypeSelect($event)"
            [disableOptionCentering]="true">
            <ngx-mat-select-search [formControl]="activityCtrl"
              placeholderLabel="Search Activity Types"></ngx-mat-select-search>
            <mat-option *ngFor="let activityType of filteredActivityTypes" [value]="activityType">
              {{ activityType }}
            </mat-option>
            <mat-option *ngIf="filteredActivityTypes.length === 0" disabled>
              No options found
            </mat-option>
          </mat-select>
        </div>
        <p class="pr-4 m-0">
        <div class="form-control form-control-sm matformheight"
          *ngIf="!statusDropdown && !activityDropdown && !orbisDropdown && !workflowDropdown">
          <form class="form-width-325">
            <mat-form-field class="form-width-325">
              <input class="form-width-325" matInput aria-label="State"
                (keydown)="resetOtherFields('CmpNameeModel',$event)" (keyup)="onItemKey($event)"
                [matAutocomplete]="auto" [formControl]="userQuestionUpdate">
              <mat-autocomplete #auto="matAutocomplete" class="custom-autocomplete autocomplete-display-block">
                <ng-container *ngIf="CIdentifierValue.length > 0 && enterKey; else noResults">
                  <mat-option class="form-width-325" *ngFor="let value of CIdentifierValue"
                    (click)="onIdentivalueSelect(value)" [value]="value" tabindex="0"
                    (keydown.enter)="onIdentivalueSelect(value)"
                    (keydown.space)="onIdentivalueSelect(value)">
                    <span>{{ value }}</span>
                  </mat-option>
                </ng-container>
                <ng-template #noResults>
                  <mat-option class="noResults" disabled
                    *ngIf="IdentifierValueModel.length >= 5 && !autoload1 && enterKey">
                    <span>No results</span>
                  </mat-option>
                </ng-template>
              </mat-autocomplete>
            </mat-form-field>
            <small class="float-right search-close-btn" title="Clear">
              <button
                type="button"
                class="cancel closeBtn"
                (click)="clearFields('IdentifierValueFLag')"
                (keydown.enter)="clearFields('IdentifierValueFLag')"
                (keydown.space)="clearFields('IdentifierValueFLag')"
                tabindex="0">
                X
            </button>
            </small>
            <small class="float-right search-close-btn" *ngIf="autoload1"><img src="assets/images/loading.gif"
                class="loadingheight" alt="Updating..."></small>
          </form>
        </div>
        <div class="pr-4 m-0" *ngIf="statusDropdown && !activityDropdown && !orbisDropdown && !workflowDropdown">
          <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="selectedStatus"
            panelClass="dropdown-panel" [disableOptionCentering]="true">
            <ng-container *ngIf="CompanyStatusAll.length>0"></ng-container>
            <mat-option *ngFor="let statuslist of CompanyStatusAll" value="{{statuslist.row_id}}">
              {{statuslist.code}}</mat-option>
          </mat-select>
        </div>
        <div class="pr-4 m-0" *ngIf="orbisDropdown && !statusDropdown && !activityDropdown && !workflowDropdown">
          <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="selectedOrbisStatus"
             panelClass="dropdown-panel" [disableOptionCentering]="true">
            <ng-container *ngIf="OrbisStatusAll.length>0"></ng-container>
            <mat-option *ngFor="let statuslist of OrbisStatusAll" value="{{statuslist}}">{{statuslist}}</mat-option>
          </mat-select>
        </div>
        <div class="pr-4 m-0" *ngIf="workflowDropdown && !statusDropdown && !activityDropdown && !orbisDropdown">
          <mat-select class="form-control form-control-sm dropdown-select" [(ngModel)]="selectedWorkflowStatus"
             panelClass="dropdown-panel" [disableOptionCentering]="true">
            <ng-container *ngIf="WorkflowStatusAll.length>0"></ng-container>
            <mat-option *ngFor="let statuslist of WorkflowStatusAll" value="{{statuslist}}">{{statuslist}}</mat-option>
          </mat-select>
        </div>
      </div>

      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right search-actions"
        *ngIf="!roleVariableHide">
        <mat-label class="label-control hidden"> &nbsp; </mat-label>
        <button type="button" class="btn btn-custom btn-link" (click)="clearFields('All')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('All'))"> Clear All </button>
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue btn-ht" (click)="getSearch()"> Search
        </button>
      </div>
    </div>

    <div class="row m-0 align-center search-actions-row">
      <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right search-actions" *ngIf="roleVariableHide">
        <mat-label class="label-control hidden"> &nbsp; </mat-label>
        <button type="button" class="btn btn-custom btn-link" (click)="clearFields('All')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (clearFields('All'))"> Clear All </button>
        <button type="button" class="btn btn-custom btn-custom-lg btn-blue btn-ht" (click)="getSearch()"> Search
        </button>
      </div>
    </div>
  </section>

  <section class="col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
    <div class="row m-0 pt-3 align-center">
      <div class="col col-12 col-sm-9 col-md-10 col-lg-10 col-xl-10">
        <h4 class="title">RESULTS <span *ngIf="loadData==true && data && data.length>=0">({{PageTotalLength}})</span>
        </h4>
      </div>

      <div class="col col-12 col-sm-3 col-md-2 col-lg-2 col-xl-2">
        <button type="button" class="btn btn-custom btn-purple float-right btn-ht btn-width-93"
          *ngIf="superUserShow">
          <mat-icon svgIcon="download" class="thick-icon download-icon"></mat-icon><span class="float-right"> Export </span>
        </button>
      </div>
    </div>

    <div class="row m-0">
      <div class="table-responsive mt-3">
        <div [ngClass]="{ 'fixTableHead' :loadData == true,'fixTableFoot' :loadData == true}">
          <table class="table table-sm m-0">
            <thead>
              <tr>
                <th class="sortDecorationunderline th-left-width-3" (click)="sort('legalName')" tabindex="0"
                    (keydown.enter)="sort('legalName')" (keydown.space)="sort('legalName')">
                  Company Name
                </th>
                <th class="th-left-no-decoration">Company Short Name</th>
                <th class="sortDecorationunderline th-left-width-1" (click)="sort('companyStatusCode')" tabindex="0"
                    (keydown.enter)="sort('companyStatusCode')" (keydown.space)="sort('companyStatusCode')">
                  Company Status
                  <div>Workflow Status</div>
                </th>
                <th class="sortDecorationunderline th-left-width-1" (click)="sort('allianceIdentifier')" tabindex="0"
                    (keydown.enter)="sort('allianceIdentifier')" (keydown.space)="sort('allianceIdentifier')">
                  Company ID
                </th>
                <th *ngIf="showForSupplier" class="th-left-no-decoration-width-1">BvD ID</th>
                <th class="th-left-no-decoration-width-1">Supplier code (COFOR)</th>
                <th class="th-left-no-decoration">Country</th>
                <th class="th-left-no-decoration-width-0">City</th>
                <th class="th-left-no-decoration">Group</th>
              </tr>
            </thead>

            <tbody *ngIf="loadData==true && data && data.length>=0" #customLoadingTemplate>
              <tr *ngFor="let cmData of data | orderBy: key:reverse;let i=index">
                <td><a class="font-weight-bold label-darkblue" [routerLink]="['/company-details',cmData.rowId]">{{cmData
                    ? cmData.legalName : ''}}</a></td>
                <td><span
                    *ngIf="ShortNameData.length>0 && ShortNameData[cmData.rowId]">{{ShortNameData[cmData.rowId].value ?
                    ShortNameData[cmData.rowId].value : ''}}</span></td>
                <td> <span class="group-status"
                    *ngIf="cmData.companyStatusCode !='' && cmData.companyStatusCode!=undefined"
                    [ngStyle]="{'background':colors[cmData.companyStatusCode.toLowerCase()],
                      'min-width': '82px','float': 'left'}">{{cmData.companyStatusCode}}</span>
                  <span class="group-status"
                    [ngStyle]="{'background':workflowStatusColors[cmData.workflowStatus || cmData.workflowStatusCode || 'NotStarted'] || '#D8C4A0',
                      'min-width': '82px','float': 'left','clear': 'both','margin-top': '6px'}">
                    {{cmData.workflowStatus || cmData.workflowStatusCode || 'NotStarted'}}
                  </span>
                </td>
                <td>{{cmData ? cmData.allianceIdentifier : ''}}</td>
                <td *ngIf="showForSupplier">
                  <span *ngIf="BvdIDData[cmData['rowId']]">
                    {{BvdIDData[cmData['rowId']].value ? BvdIDData[cmData['rowId']].value : ''}}
                  </span>
                </td>
                <td>
                  <span *ngIf="alcorCodesOnCpyIds[cmData.rowId]">
                    <ul class="row m-0 nav list-view p-0" *ngFor="let alcors of alcorCodesOnCpyIds[cmData.rowId]">
                      <li>{{alcors}}</li>
                    </ul>
                  </span>
                </td>
                <td><span *ngIf="cityAndCountryData">{{cityAndCountryData[cmData.rowId] ?
                    cityAndCountryData[cmData.rowId].countryName : '--'}}</span></td>
                <td><span *ngIf="cityAndCountryData">{{cityAndCountryData[cmData.rowId] ?
                    cityAndCountryData[cmData.rowId].cityName : '--'}}</span></td>
                <td><a class="font-weight-bold label-darkblue"
                    [routerLink]="['/supplier-group-details',CmpRouting[cmData['rowId']]]"><span
                      *ngIf="CmpIdgroupAssign[cmData['rowId']]"
                      [innerHtml]="CmpIdgroupAssign[cmData['rowId']]"></span></a></td>
              </tr>
            </tbody>
            <tbody *ngIf="loadData == false" #customLoadingTemplate>
              <tr>
                <td colspan="9" *ngIf="showForSupplier" class="font-weight-bold text-darkblue text-center"> No Results
                </td>
                <td colspan="8" *ngIf="!showForSupplier" class="font-weight-bold text-darkblue text-center"> No Results
                </td>
              </tr>
            </tbody>
            <tfoot *ngIf="data && data.length>0 && PageTotalLength>20">
              <tr>
                <td colspan="9">
                  <ul *ngIf="pager.pages && pager.pages.length" class="pagination">
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="selectedCIddentifier2('','','',1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',1,'cked'))">First</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === 1}">
                      <a (click)="selectedCIddentifier2('','','',pager.currentPage - 1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',pager.currentPage - 1,'cked'))">Previous</a>
                    </li>
                    <li *ngFor="let page of pager.pages" [ngClass]="{active:pager.currentPage === page}">
                      <a (click)="selectedCIddentifier2('','','',page,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',page,'cked'))">{{page}}</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="selectedCIddentifier2('','','',pager.currentPage + 1,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',pager.currentPage + 1,'cked'))">Next</a>
                    </li>
                    <li [ngClass]="{disabled:pager.currentPage === pager.totalPages}">
                      <a (click)="selectedCIddentifier2('','','',pager.totalPages,'cked')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',pager.totalPages,'cked'))">Last</a>
                    </li>
                  </ul>
                </td>
              </tr>
            </tfoot>
            <ng-container *ngIf="loading">
              <div class="local-loading-overlay">
                <div class="custom-spinner-template">
                  <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                </div>
              </div>
            </ng-container>
          </table>
        </div>
      </div>
    </div>
  </section>
</div>

<div class="modal fade" id="createCompanyModalPopup" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel">
          Create Company by <span class="label-blue">ADMIN</span>
          <button type="button" class="close" id="closeCompBtn" #closeBtn data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-body">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <mat-label class="label-control">Company Name
            </mat-label>
            <input type="text" [attr.maxLength]="maxCpyNameLength" id="companyNameField"
              class="form-control form-control-sm" [(ngModel)]="companyNameModel"
              (keyup)="checkvalidateCompanyNameField(companyNameModel, 'companyNameModel',
                'companyNameModelError', 'companyNameModelRegExError')"
              (ngModelChange)="companyNameModel = $event.toUpperCase()">
            <span class="ng-clear-wrapper datalistClearButton" title="Clear all">
              <button type="button" class="ng-clear cancel"
                (click)="resetCompanyNameFields()" tabindex="0"
                (keydown.enter)="resetCompanyNameFields()"
                (keydown.space)="resetCompanyNameFields()">
                ×
              </button>
            </span>
            <span class="error-color" *ngIf="companyNameModelError==true">Please enter company name!!!</span>
            <span class="error-color" *ngIf="companyNameModelRegExError==true">A-Z 0-9 space () . , - /</span>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-link" data-dismiss="modal"
            id="closeCompBtn1" #closeBtn data-dismiss="modal"> Cancel </button>
          <button type="button" class="btn btn-custom btn-custom-sm btn-blue" (click)="saveCompanyDetails()"
            [disabled]="disableCompCreateBtn==true">
            <mat-icon svgIcon="mail" class="img-btn mr-2"></mat-icon> <span class="float-right"> {{saveDatas}}</span>
          </button>
        </section>
      </div>
    </div>
  </div>
</div>
<div class="modal fade" id="payingDataModal" tabindex="-1" aria-modal="true" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-custom">
    <div class="modal-content payingCompanyTable">
      <div class="modal-header border-0">
        <h6 class="modal-title font-weight-bold text-center" id="exampleModalLabel1">
          Paying Company Database
          <button type="button" class="close" id="closePayingCpyDatabase" #closeBtn data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h6>
      </div>

      <div class="modal-title mt-2 pr-2">
        <button type="button" class="btn btn-custom btn-blue backblue float-right d-flex align-center py-2 px-2">
          <mat-icon svgIcon="add" class="img-btn"></mat-icon>
        </button>
      </div>


      <div class="modal-body row m-0 p-0 table-responsive modal-body-height-300">
        <section class="row m-0 bg-white no-shadow">
          <div class="form-group col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 p-0">
            <div class="modal-body row m-0 p-0">
              <table class="table m-0">
                <thead class="thead-bg-gray TableSticky">
                  <tr class="col p-0">
                    <th class="sortDecorationunderline" (click)="sortPayingCompany('code')" tabindex="0"
                      (keydown.enter)="sortPayingCompany('code')" (keydown.space)="sortPayingCompany('code')">Code</th>
                    <th class="sortDecorationunderline" (click)="sortPayingCompany('legalName')" tabindex="0"
                      (keydown.enter)="sortPayingCompany('legalName')" (keydown.space)="sortPayingCompany('legalName')">Name</th>
                    <th class="sortDecorationunderline" (click)="sortPayingCompany('grouping')" tabindex="0"
                      (keydown.enter)="sortPayingCompany('grouping')" (keydown.space)="sortPayingCompany('grouping')">Grouping</th>
                    <th class="sortDecorationunderline" (click)="sortPayingCompany('startDate')" tabindex="0"
                      (keydown.enter)="sortPayingCompany('startDate')" (keydown.space)="sortPayingCompany('startDate')">Start Date</th>
                    <th class="sortDecorationunderline" (click)="sortPayingCompany('endDate')" tabindex="0"
                      (keydown.enter)="sortPayingCompany('endDate')" (keydown.space)="sortPayingCompany('endDate')">End Date</th>
                  </tr>
                </thead>

                <tbody *ngIf="payingCpyData.length>0 && payingCpyLoading==false">
                  <tr *ngFor="let cpyPay of payingCpyData; let i = index" class="forColor p-0">
                    <td class="tdCustom font-weight-bold">{{cpyPay.code ? cpyPay.code : '-'}}</td>
                    <td class="tdCustom font-weight-bold">{{cpyPay.legalName ? cpyPay.legalName : '-'}}</td>
                    <td class="tdCustom">{{cpyPay.grouping ? cpyPay.grouping : ''}}</td>
                    <td class="tdCustom">{{cpyPay.startDate ? cpyPay.startDate : ''}}</td>
                    <td class="tdCustom">{{cpyPay.endDate ? cpyPay.endDate : ''}}</td>
                  </tr>
                </tbody>

                <tbody *ngIf="payingCpyData.length==0 || payingCpyLoading==true">
                  <tr>
                    <td colspan="5" class="font-weight-bold text-darkblue text-center">No Results</td>
                  </tr>
                </tbody>
                <tfoot class="TableSticky" *ngIf="payingCpyLoading == false && payingCpyData.length > 0">
                  <tr>
                    <td colspan="5" class="td-bg-gray">

                      <ul *ngIf="payPager.pages && payPager.pages.length" class="pagination">
                        <li [ngClass]="{disabled:payPager.currentPage === 1}">
                          <a (click)="selectedCIddentifier2('','','',1,'ckedd')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',1,'ckedd'))">First</a>
                        </li>
                        <li [ngClass]="{disabled:payPager.currentPage === 1}">
                          <a (click)="selectedCIddentifier2('','','',payPager.currentPage - 1,'ckedd')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',payPager.currentPage - 1,'ckedd'))">Previous</a>
                        </li>
                        <li *ngFor="let page of payPager.pages" [ngClass]="{active:payPager.currentPage === page}">
                          <a (click)="selectedCIddentifier2('','','',page,'ckedd')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',page,'ckedd'))">{{page}}</a>
                        </li>
                        <li [ngClass]="{disabled:payPager.currentPage === payPager.totalPages}">
                          <a (click)="selectedCIddentifier2('','','',payPager.currentPage + 1,'ckedd')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',payPager.currentPage + 1,'ckedd'))">Next</a>
                        </li>
                        <li [ngClass]="{disabled:payPager.currentPage === payPager.totalPages}">
                          <a (click)="selectedCIddentifier2('','','',payPager.totalPages,'ckedd')" tabindex="0" role="button" (keydown)="($event.key === 'Enter' || $event.key === ' ') && (selectedCIddentifier2('','','',payPager.totalPages,'ckedd'))">Last</a>
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tfoot>
                <ng-container *ngIf="payingCpyLoading">
                  <div class="local-loading-overlay">
                    <div class="custom-spinner-template">
                      <mat-spinner class="custom-spinner black-spinner" diameter="40"></mat-spinner>
                    </div>
                  </div>
                </ng-container>
              </table>
            </div>
          </div>
        </section>
      </div>

      <div class="modal-footer border-0">
        <section class="bg-white no-shadow m-0">
          <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal"> Cancel
          </button>&nbsp;&nbsp;
          <button type="button" class="btn btn-custom btn-custom-md btn-blue" data-dismiss="modal">
            OK
          </button>
        </section>
      </div>
    </div>
  </div>
</div>

<div class="display-none">
  <button id="btnForHQContinue" data-target="#showAlreadyRunBatch" data-toggle="modal"></button>
  <button id="btnForHQStart" data-target="#showCpyHQBatch" data-toggle="modal"></button>
  <button id="btnForHQCheckOnStart" data-target="#showConfirmStartBatch" data-toggle="modal"></button>
</div>
</div>